export default "__VITE_ASSET__5850f3af__"